function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "none",
    cx: 4,
    cy: 4,
    r: 4,
    style: {
      transformOrigin: "50% 50%",
      animationTimingFunction: "ease-out",
      animationDuration: "1500ms",
      animationIterationCount: "infinite",
      animationName: "pulse"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleLight);
export default __webpack_public_path__ + "static/media/circle-light.0248d4f3a76eb44b1ed93aecb5cbde78.svg";
export { ForwardRef as ReactComponent };